import { gql } from '@apollo/client'

export const ROOMTYPE_GENERATE_MUTATION = gql`
  mutation GenerateRoomType($input: RoomTypeInput!, $propertyCode: String!) {
    generateRoomType(input: $input, propertyCode: $propertyCode) {
      message
    }
  }
`
